/**
 * 中国法定节假日 + 调休数据
 *
 * 数据来源：国务院办公厅每年发布的放假通知
 * 维护说明：每年 11-12 月国务院发布次年放假通知后，更新此处
 *
 * 推荐方案（后期）：使用 chinese-workday 或 holiday-cn 等社区库自动获取
 */

export interface HolidayInfo {
  date: string; // YYYY-MM-DD
  name: string; // 节日名称，如"劳动节"
  type: 'rest' | 'work'; // rest=放假, work=调休上班
}

/**
 * 2026 年节假日数据（示例，需每年更新）
 * 注：实际数据请以国务院公告为准
 */
const HOLIDAYS_2026: HolidayInfo[] = [
  // 元旦
  { date: '2026-01-01', name: '元旦', type: 'rest' },
  { date: '2026-01-02', name: '元旦', type: 'rest' },
  { date: '2026-01-03', name: '元旦', type: 'rest' },

  // 春节
  { date: '2026-02-16', name: '春节', type: 'rest' },
  { date: '2026-02-17', name: '春节', type: 'rest' },
  { date: '2026-02-18', name: '春节', type: 'rest' },
  { date: '2026-02-19', name: '春节', type: 'rest' },
  { date: '2026-02-20', name: '春节', type: 'rest' },
  { date: '2026-02-21', name: '春节', type: 'rest' },
  { date: '2026-02-22', name: '春节', type: 'rest' },

  // 清明
  { date: '2026-04-04', name: '清明节', type: 'rest' },
  { date: '2026-04-05', name: '清明节', type: 'rest' },
  { date: '2026-04-06', name: '清明节', type: 'rest' },

  // 劳动节
  { date: '2026-05-01', name: '劳动节', type: 'rest' },
  { date: '2026-05-02', name: '劳动节', type: 'rest' },
  { date: '2026-05-03', name: '劳动节', type: 'rest' },
  { date: '2026-05-04', name: '劳动节', type: 'rest' },
  { date: '2026-05-05', name: '劳动节', type: 'rest' },
  { date: '2026-05-09', name: '调休上班', type: 'work' },

  // 端午
  { date: '2026-06-19', name: '端午节', type: 'rest' },
  { date: '2026-06-20', name: '端午节', type: 'rest' },
  { date: '2026-06-21', name: '端午节', type: 'rest' },

  // 国庆 + 中秋
  { date: '2026-10-01', name: '国庆节', type: 'rest' },
  { date: '2026-10-02', name: '国庆节', type: 'rest' },
  { date: '2026-10-03', name: '国庆节', type: 'rest' },
  { date: '2026-10-04', name: '国庆节', type: 'rest' },
  { date: '2026-10-05', name: '国庆节', type: 'rest' },
  { date: '2026-10-06', name: '国庆节', type: 'rest' },
  { date: '2026-10-07', name: '国庆节', type: 'rest' },
  { date: '2026-10-08', name: '国庆节', type: 'rest' },
];

const HOLIDAYS_MAP: Record<string, HolidayInfo> = {};
for (const h of HOLIDAYS_2026) {
  HOLIDAYS_MAP[h.date] = h;
}

/**
 * 查询某天的节假日/调休信息
 * @param date YYYY-MM-DD
 * @returns 节假日信息，无则 null
 */
export function getHoliday(date: string): HolidayInfo | null {
  return HOLIDAYS_MAP[date] || null;
}

/**
 * 获取某月所有的节假日
 * @param yearMonth YYYY-MM
 */
export function getHolidaysByMonth(yearMonth: string): HolidayInfo[] {
  return HOLIDAYS_2026.filter((h) => h.date.startsWith(yearMonth));
}
